
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      export default {
  data: function () {
    if (!localStorage.notfirstRun) {
      this.$app.toast.create({
        text: 'By using this app, you are accepting the Privacy Policy & License of AttnSheet, Framework7 & Google (and other product(s) assositated with it.',
        closeTimeout: 5000
      }).open();
      localStorage.notfirstRun = true;
    }
    return { rooms: JSON.parse(localStorage.getItem('rooms')) };
  },
  methods: {
    reload: function (e, done) {
      let x = JSON.parse(localStorage.getItem('rooms'));
      this.$setState({ rooms: x });
      done();
    }
  },
  id: 'cd73a13c64',
  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }
      function isFunction(func) {
        return typeof func === 'function';
      }
      function c(val, ctx) {
        if (typeof val !== 'undefined' && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else
            return val;
        } else
          return '';
      }
      root = root || ctx_1 || {};
      var r = '';
      r += '\n  <div class="page" data-name="home">\n    <!-- Top Navbar -->\n    <div class="navbar navbar-large">\n      <div class="navbar-bg"></div>\n      <div class="navbar-inner">\n        <!-- <div class="left">\n          <a href="#" class="link icon-only panel-open" data-panel="left">\n            <i class="icon f7-icons if-not-md">menu</i>\n            <i class="icon material-icons if-md">menu</i>\n          </a>\n        </div> -->\n        <div class="title sliding">AttnSheet</div>\n        <div class="title-large">\n          <div class="title-large-text">AttnSheet</div>\n        </div>\n      </div>\n    </div>\n\n    <!-- Scrollable page content-->\n    <div class="page-content ptr-content" data-ptr-mousewheel="true" @ptr:refresh="reload">\n      <div class="ptr-preloader">\n        <div class="preloader"></div>\n        <div class="ptr-arrow"></div>\n      </div>\n      <!-- Add/Remove room/class -->\n      <div class="list links-list">\n        <ul>\n          ';
      r += Template7Helpers.each.call(ctx_1, ctx_1.rooms, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '\n            <li><a href="/class/';
          r += c(ctx_2.id, ctx_2);
          r += '/?index=';
          r += c(data_2 && data_2.index, ctx_2);
          r += '&title=';
          r += c(ctx_2.alias, ctx_2);
          r += '">';
          r += c(ctx_2.alias, ctx_2);
          r += '</a></li>\n          ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '\n        </ul>\n      </div>\n    </div>\n  </div>\n';
      return r;
    }(this);
  },
  styleScoped: false
};
    